import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { routes } from './address-book.routes';
import { AddressBookComponent } from './address-book.component';
import { AddressBookService } from './address-book.service';
import { BrowserModule } from '@angular/platform-browser';
import { AppService } from '../app.service';
import { HttpModule } from '@angular/http';

import { CompanyItemComponent } from './company-item.component';
import { CompanyContactComponent } from './company-contact.component';
import { SharedModule } from '../shared/shared.module';
import { AssetManagerModule } from '../shared/asset-manager.module';

@NgModule({
  declarations: [
    /**
     * Components / Directives/ Pipes
     */
    AddressBookComponent,
    CompanyItemComponent,
    CompanyContactComponent,

  ],
  imports: [
    FormsModule,
    ReactiveFormsModule,
    SharedModule,
    RouterModule.forChild(routes),
  ],
   providers: [
    AddressBookService
  ]
})
export class AddressBookModule {
  public static routes = routes;
}


// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/address-book/address-book.module.ts